import React from 'react';
import { motion } from 'framer-motion';

const BackgroundLayout = ({ children, className = "" }) => {
    return (
        <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1 }}
            className={`relative flex flex-col items-center w-full min-h-screen bg-[#fff5f5] max-w-full ${className}`}
            style={{ overflowX: 'clip' }}
        >
            {/* Background elements (blurred circles) — pointer-events-none so they never block touch */}
            <div className="pointer-events-none absolute top-[-10%] left-[-10%] w-[60%] h-[60%] bg-[#f8485e] rounded-full mix-blend-multiply filter blur-[120px] opacity-15 animate-slower-pulse animate-float" />
            <div className="pointer-events-none absolute bottom-[-10%] right-[-10%] w-[60%] h-[60%] bg-[#f8485e] rounded-full mix-blend-multiply filter blur-[120px] opacity-15 animate-slower-pulse animate-float" style={{ animationDelay: '4s' }} />
            <div className="pointer-events-none absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-[#f8485e] rounded-full mix-blend-multiply filter blur-[150px] opacity-10 animate-slow-pulse" />

            <div className="relative z-10 w-full flex flex-col items-center">
                {children}
            </div>
        </motion.div>
    );
};

export default BackgroundLayout;
